import { Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import MatchedIcon from "../Assets/Icons/matchedIcon.svg";

export default function MatchhingModal({ open, setOpen }) {
  const cancelButtonRef = useRef(null);

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-[42rem] sm:max-w-lg">
                <div className="bg-white px-3 pb-4 pt-4 sm:p-3 sm:pb-4">
                  <div className="sm:flex sm:items-start sm:flex-col">
                    <div className="w-full">
                      <p className="text-[1.1rem] text-[#111928] font-bold">
                        Matching AI Team
                      </p>
                      <div className="w-[100%] h-[1px] bg-[#E5E7EB] mt-2"></div>
                    </div>
                    <div className="flex items-center flex-col justify-center gap-2 mt-4">
                      <img src={MatchedIcon} />
                      <p className="text-[1.1rem] text-[#111928] font-[700]">
                        Looking for Matched AI Teams
                      </p>
                      <p className="text-[1rem] text-[#6B7280] text-center">
                        Based on your project description, we are connecting you
                        to the most compatible team.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="px-4 w-full py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    className="mt-2 inline-flex w-full justify-center rounded-md bg-[#E5E7EB] px-3 py-2 text-sm font-semibold text-[#1F2A37] shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-[-10px] sm:w-full"
                    onClick={() => setOpen(false)}
                    ref={cancelButtonRef}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
